class morePriceBtn {
  items = document.querySelectorAll(".coll-item");

  constructor() {
    this.btnToggler();
  }

  btnToggler() {
    window.addEventListener(
      "click",
      function (e) {
        const btn = e.target.closest(".tgBtn");
        if (!btn) return;

        this.items.forEach((item) => {
          item.classList.toggle("d-none");
        });

        btn.querySelectorAll("h6").forEach((el) => {
          el.classList.toggle("d-none");
        });
      }.bind(this)
    );
  }
}

export default new morePriceBtn();
